import React from "react";
import {
  Dialog,
  Typography,
  DialogActions,
  DialogTitle,
  DialogContent,
  Button,
  Select,
  InputLabel,
  MenuItem,
  FormControl,
  InputAdornment,
  Collapse,
  IconButton,
  Link,
  FormControlLabel,
  Switch,
  TextField,
  OutlinedInput,
} from "@mui/material";

import { Alert } from '@mui/material';
import {
  Close as CloseIcon,
  FileCopyOutlined as FileCopyOutlinedIcon,
} from "@mui/icons-material";

import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";

import { copyStringToClipboard } from "utils";
import "./style.css";
const aspects = [
  {
    value: "16/9",
    label: "16 / 9",
  },
  {
    value: "4/3",
    label: "4 / 3",
  },
  {
    value: "1/1",
    label: "1 / 1",
  },
];

export default class UploadImageDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      src: null,
      filename: props.editUrl ? props.editUrl.split("/").slice(-1)[0] : "",
      aspect: "16/9",
      zoom: 100,
      enableCropping: false,
      enableFixedSize: true,
      fixedSize: {
        width: 800,
        height: 450,
      },
      dpi: 140,
      crop: {
        unit: "%",
        width: 30,
        aspect: 16 / 9,
      },
      dim_w: 0,
      dim_h: 0,
      alertOpened: false,
      alertType: 0,
      alertMessage: "",
      bImageUploaded: false,
    };
  }

  fetchImage = async (url) => {
    let blob = await fetch(url).then((r) => r.blob());
    let blobUrl = URL.createObjectURL(blob);
    this.setState({ src: blobUrl });
  };

  componentDidMount = () => {
    if (this.props.editUrl) this.fetchImage(this.props.editUrl);
  };

  UNSAFE_componentWillReceiveProps = (props) => {
    const { uploadError, uploadedImage } = props;
    const newUploadError = uploadError;
    const prevUploadError = this.props.uploadError;

    this.setState({ bImageUploaded: false });

    if (prevUploadError === -1 && newUploadError >= 0) {
      this.setState({
        alertOpened: true,
        alertType: newUploadError,
        alertMessage:
          newUploadError === 0
            ? "Upload image successed"
            : "Upload image failed",
        uploadedImage,
        bImageUploaded: true,
      });
    }
  };

  onUpload = () => {
    const { handleUpload } = this.props;

    const {
      enableCropping,
      croppedImageUrl,
      uploadedFile,
      filename,
      credit,
      dpi,
      enableFixedSize,
      fixedSize,
    } = this.state;
    let compressOption = {
      dpi,
    };
    if (enableFixedSize) compressOption = { ...compressOption, ...fixedSize };

    if (enableCropping) {
      if (!croppedImageUrl) return;
      var xhr = new XMLHttpRequest();
      xhr.open("GET", croppedImageUrl, true);
      xhr.responseType = "blob";
      xhr.onload = function (e) {
        if (this.status === 200) {
          var blob = this.response;
          var file = new File([blob], "uploadFile.png");
          typeof handleUpload === "function" &&
            handleUpload(file, filename, compressOption, credit);
        }
      };
      xhr.send();
    } else {
      if (!uploadedFile) return;
      typeof handleUpload === "function" &&
        handleUpload(uploadedFile, filename, compressOption, credit);
    }
  };

  onSelectFile = (e) => {
    const _self = this;
    if (e.target.files && e.target.files.length > 0) {
      this.setState({
        uploadedFile: e.target.files[0],
      });
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        this.setState({ src: reader.result });

        // get image size
        var img = new Image();
        img.onload = function () {
          if (this.width < 800 || this.height < 450) {
            _self.setState({
              alertOpened: true,
              alertType: 2,
              alertMessage: "The image larger than 800x450 is recommended.",
            });
          } else {
            _self.setState({
              alertOpened: false,
            });
          }
        };
        img.src = reader.result;
        // end get image size
      });
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  onImageLoaded = (image) => {
    this.imageRef = image;
  };

  onCropComplete = (crop) => {
    this.makeClientCrop(crop);
  };

  onCropChange = (crop, percentCrop) => {
    this.setState({ crop });
  };

  async makeClientCrop(crop) {
    if (this.imageRef && crop.width && crop.height) {
      const croppedImageUrl = await this.getCroppedImg(
        this.imageRef,
        crop,
        "uploadFile.png"
      );
      this.setState({ croppedImageUrl });
    }
  }

  getCroppedImg(image, crop, fileName) {
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          //reject(new Error('Canvas is empty'));
          return;
        }
        blob.name = fileName;
        window.URL.revokeObjectURL(this.fileUrl);
        this.fileUrl = window.URL.createObjectURL(blob);
        resolve(this.fileUrl);
      }, "image/jpeg");
    });
  }

  onUpdateAspect = (aspect) => {
    let crop = {};
    switch (aspect) {
      case "origin":
        crop = {};
        break;
      case "16/9":
        crop = { unit: "%", width: 30, aspect: 16 / 9 };
        break;
      case "4/3":
        crop = { unit: "%", width: 30, aspect: 4 / 3 };
        break;
      case "1/1":
        crop = { unit: "%", width: 50, aspect: 1 / 1 };
        break;
      default:
        crop = { unit: "%", width: 30, aspect: 16 / 9 };
        break;
    }
    this.setState({ aspect, crop });
  };

  _renderAlert = () => {
    const { alertOpened, alertType, alertMessage, uploadedImage } = this.state;
    return (
      <div>
        <Collapse in={alertOpened}>
          <Alert
            variant="filled"
            severity={
              alertType === 0
                ? "success"
                : alertType === 1
                ? "error"
                : "warning"
            }
            style={{
              alignItems: "center",
            }}
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => this.setState({ alertOpened: false })}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              {alertMessage}
              {alertType === 0 && (
                <div style={{ marginLeft: "1rem" }}>
                  <Link href={uploadedImage} target="blank" underline="hover">
                    {uploadedImage}
                  </Link>
                  <IconButton onClick={() => copyStringToClipboard(uploadedImage)} size="large">
                    <FileCopyOutlinedIcon />
                  </IconButton>
                </div>
              )}
            </div>
          </Alert>
        </Collapse>
      </div>
    );
  };

  _renderDimensionSettings = () => {
    const {
      enableCropping,
      enableFixedSize,
      aspect,
      crop,
      zoom,
      fixedSize,
      dpi,
    } = this.state;
    return (
      <div>
        <div style={{ display: "flex", alignItems: "baseline" }}>
          <FormControlLabel
            label="Enable Crop"
            control={
              <Switch
                checked={enableCropping}
                onClick={() =>
                  this.setState({ enableCropping: !enableCropping })
                }
              />
            }
          />
          {enableCropping ? (
            <div style={{ display: "flex", alignItems: "baseline" }}>
              <FormControl
                margin="dense"
                size="small"
                variant="outlined"
                style={{ minWidth: 100 }}
              >
                <InputLabel>Aspect</InputLabel>
                <Select
                  label="Aspect"
                  value={aspect}
                  onChange={(e) => this.onUpdateAspect(e.target.value)}
                >
                  {aspects.map((item, id) => (
                    <MenuItem key={id} value={item.value}>
                      {item.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginLeft: "1rem",
                }}
              >
                <FormControl
                  margin="dense"
                  size="small"
                  variant="outlined"
                  style={{ width: 120 }}
                >
                  <InputLabel>Width</InputLabel>
                  <OutlinedInput
                    value={Math.round(crop.width)}
                    onChange={(e) =>
                      this.setState({
                        crop: {
                          ...crop,
                          width: parseInt(e.target.value, 10),
                          height: crop.aspect
                            ? e.target.value / crop.aspect
                            : crop.height,
                        },
                      })
                    }
                    inputProps={{ type: "number" }}
                    endAdornment={
                      <InputAdornment position="end">px</InputAdornment>
                    }
                  />
                </FormControl>
                <FormControl
                  margin="dense"
                  size="small"
                  variant="outlined"
                  style={{ marginLeft: "1rem", width: 120 }}
                >
                  <InputLabel>Height</InputLabel>
                  <OutlinedInput
                    value={Math.round(crop.height)}
                    onChange={(e) =>
                      this.setState({
                        crop: {
                          ...crop,
                          width: crop.aspect
                            ? e.target.value * crop.aspect
                            : crop.width,
                          height: parseInt(e.target.value, 10),
                        },
                      })
                    }
                    inputProps={{ type: "number" }}
                    endAdornment={
                      <InputAdornment position="end">px</InputAdornment>
                    }
                  />
                </FormControl>
                <FormControl
                  margin="dense"
                  size="small"
                  variant="outlined"
                  style={{ marginLeft: "1rem", width: 120 }}
                >
                  <InputLabel>Max Width</InputLabel>
                  <OutlinedInput
                    value={zoom}
                    onChange={(e) => this.setState({ zoom: e.target.value })}
                    inputProps={{ type: "number", max: 100, min: 1 }}
                    endAdornment={
                      <InputAdornment position="end">%</InputAdornment>
                    }
                  />
                </FormControl>
              </div>
            </div>
          ) : null}
        </div>
        <Typography variant="body2" color="textSecondary">
          Compression
        </Typography>
        <div style={{ display: "flex", alignItems: "baseline" }}>
          <FormControlLabel
            label="Enable Fixed Size"
            control={
              <Switch
                checked={enableFixedSize}
                onClick={() =>
                  this.setState({ enableFixedSize: !enableFixedSize })
                }
              />
            }
          />
          {enableFixedSize ? (
            <div style={{ display: "flex", alignItems: "baseline" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginLeft: "1rem",
                }}
              >
                <FormControl
                  margin="dense"
                  size="small"
                  variant="outlined"
                  style={{ width: 120 }}
                >
                  <InputLabel>Width</InputLabel>
                  <OutlinedInput
                    value={Math.round(fixedSize.width)}
                    onChange={(e) =>
                      this.setState({
                        fixedSize: {
                          ...fixedSize,
                          width: parseInt(e.target.value, 10),
                        },
                      })
                    }
                    inputProps={{ type: "number" }}
                    endAdornment={
                      <InputAdornment position="end">px</InputAdornment>
                    }
                  />
                </FormControl>
                <FormControl
                  margin="dense"
                  size="small"
                  variant="outlined"
                  style={{ marginLeft: "1rem", width: 120 }}
                >
                  <InputLabel>Height</InputLabel>
                  <OutlinedInput
                    value={Math.round(fixedSize.height)}
                    onChange={(e) =>
                      this.setState({
                        fixedSize: {
                          ...fixedSize,
                          height: parseInt(e.target.value, 10),
                        },
                      })
                    }
                    inputProps={{ type: "number" }}
                    endAdornment={
                      <InputAdornment position="end">px</InputAdornment>
                    }
                  />
                </FormControl>
              </div>
            </div>
          ) : null}
        </div>
        <FormControl
          margin="dense"
          size="small"
          variant="outlined"
          style={{ width: 120 }}
        >
          <InputLabel>DPI</InputLabel>
          <OutlinedInput
            value={dpi}
            onChange={(e) => this.setState({ dpi: e.target.value })}
            inputProps={{ type: "number", max: 300, min: 1 }}
          />
        </FormControl>
      </div>
    );
  };

  _renderCropper = () => {
    const { crop, src, zoom, enableCropping } = this.state;
    if (!src) return;
    return (
      <div style={{ textAlign: "center" }}>
        {enableCropping ? (
          <ReactCrop
            src={src}
            crop={crop}
            style={{
              maxWidth: `${zoom}%`,
            }}
            ruleOfThirds
            onImageLoaded={this.onImageLoaded}
            onComplete={this.onCropComplete}
            onChange={this.onCropChange}
          />
        ) : (
          <img style={{ width: "100%" }} src={src} alt="upload-thumbnail" />
        )}
      </div>
    );
  };

  render() {
    const { crop, src, enableCropping, filename, credit } = this.state;
    const { editMode } = this.props;

    return (
      <Dialog open={true} fullWidth maxWidth="lg" onClose={this.props.onClose}>
        <DialogTitle>{editMode ? "Edit Photo" : "Upload Photo"}</DialogTitle>
        <DialogContent style={{ minHeight: 300 }}>
          {this._renderAlert()}
          <div>
            {!editMode ? (
              <input
                type="file"
                accept="image/*"
                onChange={this.onSelectFile}
              />
            ) : null}
            {this._renderDimensionSettings()}

            <Typography variant="body1" style={{ color: "#f23347" }}>
              16/9 format with almost 800px width is required for the main top
              picture of news
            </Typography>
          </div>
          {this._renderCropper()}
        </DialogContent>
        <DialogActions>
          <div style={{}}>
            {src &&
              (!enableCropping ||
                (enableCropping && crop.width > 0 && crop.height > 0)) && (
                <div>
                  <div>
                    <TextField
                      margin="dense"
                      size="small"
                      variant="outlined"
                      style={{ minWidth: 200, marginRight: 15, marginTop: 0 }}
                      disabled={editMode}
                      label="Filename"
                      value={filename ? filename : ""}
                      onChange={(e) =>
                        this.setState({ filename: e.target.value })
                      }
                    />
                    <TextField
                      margin="dense"
                      variant="outlined"
                      size="small"
                      style={{ minWidth: 200, marginRight: 15, marginTop: 0 }}
                      label="Credit"
                      value={credit ? credit : ""}
                      onChange={(e) =>
                        this.setState({ credit: e.target.value })
                      }
                    />
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={this.onUpload}
                    >
                      Save
                    </Button>
                  </div>
                </div>
              )}
          </div>
        </DialogActions>
      </Dialog>
    );
  }
}
